import React from 'react';
import './LegendPlaceholder.scss';

export const LegendPlaceholder = () => <div className="legend-placeholder" />;
